import os from 'node:os';
import { platform, version as nodeVersion } from 'node:process';
import isCI from 'is-ci';
import type { Flow } from './types.js';

export function getEnvironmentInfo({
  cliVersion,
  flow,
}: {
  cliVersion: string;
  flow: Flow | null;
}) {
  return {
    ...(flow ? { flow } : {}),
    cliVersion,
    isCI,
    nodeVersion,
    osName: getOsName(),
    osVersion: os.release(),
  };
}

// https://stackoverflow.com/a/8684009
function getOsName() {
  switch (platform) {
    case 'darwin':
      return 'mac';
    case 'win32':
      return 'windows';
    default:
      return 'linux';
  }
}
